"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = void 0;
var _util = require("util");
var _querystring = _interopRequireDefault(require("querystring"));
var _auth0Js = require("auth0-js");
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const {
  prototype
} = _auth0Js.WebAuth;
['checkSession', 'parseHash'].forEach(k => {
  prototype[`${k}Async`] = (0, _util.promisify)(prototype[k]);
});
const create = (config = {}) => {
  let timeout;
  const {
    auth: authConfig = {},
    token: {
      key = 'token',
      tolerance = 0,
      cookie: {
        domain,
        expires = 1000 * 60 * 60 * 24 * 365 * 2
      } = {}
    } = {},
    logger
  } = config;
  const {
    redirectUri
  } = authConfig;
  const auth = new _auth0Js.WebAuth(authConfig);
  const log = val => {
    if (logger) {
      logger.info(val);
    }
  };
  const token = () => _jsCookie.default.get(key, {
    domain
  });
  const removeToken = () => {
    _jsCookie.default.remove(key, {
      domain
    });
  };
  const login = ({
    redirectUrl = redirectUri,
    ...options
  }) => {
    auth.authorize({
      state: JSON.stringify({
        redirectUrl
      }),
      ...options
    });
  };
  const logout = ({
    returnTo
  } = {}) => {
    clearTimeout(timeout);
    removeToken();
    auth.logout({
      returnTo: returnTo || authConfig.returnTo || redirectUri
    });
  };
  const expiresIn = accessToken => {
    const {
      exp
    } = (0, _jwtDecode.default)(accessToken);
    return exp * 1000 - Date.now() - tolerance;
  };
  const set = accessToken => _jsCookie.default.set(key, accessToken, {
    expires: new Date(new Date().getTime() + expires),
    domain
  });
  const parse = async (options = {}) => {
    const defaultOnRedirect = redirectUrl => window.history.replaceState({}, '', redirectUrl);
    const {
      onRedirect = defaultOnRedirect
    } = options;
    const {
      hash
    } = window.location;
    if (/error/.test(hash)) {
      const err = _querystring.default.parse(decodeURIComponent(hash.substring(1)));
      const error = new Error(err.error_description);
      throw Object.assign(err, error);
    }
    if (/access_token/.test(hash)) {
      const {
        accessToken,
        state
      } = await auth.parseHashAsync();
      set(accessToken);
      const {
        redirectUrl = '/'
      } = JSON.parse(state);
      await onRedirect(redirectUrl);
    }
  };
  const refresh = async (options = {}) => {
    const {
      ensureLoggedIn
    } = options;
    try {
      const {
        accessToken
      } = await auth.checkSessionAsync({});
      set(accessToken);
      log(accessToken);
    } catch (err) {
      clearTimeout(timeout);
      removeToken();
      if (ensureLoggedIn) {
        login({
          redirectUrl: window.location.pathname + window.location.search
        });
      }
    }
  };
  const scheduleRefresh = (options = {}) => {
    const repeat = async () => {
      await refresh(options);
      scheduleRefresh(options);
    };
    const accessToken = token();
    if (accessToken) {
      timeout = setTimeout(repeat, expiresIn(accessToken));
    } else {
      clearTimeout(timeout);
    }
  };
  const init = async (options = {}) => {
    const {
      onRedirect,
      ensureLoggedIn = true,
      loginOptions
    } = options;
    try {
      await parse({
        onRedirect
      });
    } catch (err) {
      removeToken();
      log(err);
    }
    const accessToken = token();
    if (accessToken) {
      log(accessToken);
      scheduleRefresh({
        ensureLoggedIn
      });
      return accessToken;
    }
    if (ensureLoggedIn) {
      login({
        redirectUrl: window.location.pathname + window.location.search,
        ...loginOptions
      });
    }
    return undefined;
  };
  return {
    login,
    logout,
    token,
    init,
    refresh
  };
};
exports.create = create;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(prototype, "prototype", "/Users/jake.clayton/frontend/ls-common-client/src/auth.js");
  reactHotLoader.register(create, "create", "/Users/jake.clayton/frontend/ls-common-client/src/auth.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();